import { Component, Renderer2, ViewChild, ElementRef, OnDestroy, OnChanges, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { GlobalEventsService } from "./shared/services/global-events.service";
import { DropDownAnimation } from "./shared/common/animations";
import { AuthorizationService } from './shared/services/authorization.service';
import { LoaderService } from './shared/services/loader.service';
import { CustomCookieService } from './shared/services/custom-cookie.service';
import { IdValidationResponse, IdValidationRequestBody } from './shared/common/classes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [DropDownAnimation]
})
export class AppComponent implements OnInit {
  title = 'MNO-Touchpoint';
  public currentRoute: string;
  public redirectRoute: string;
  public showSignOutButton: boolean;
  public showHeaderLogo: boolean;
  public regexPrivateRoutes = /^\/account(\/\w+)*$/
  @ViewChild("scrollTarget") target: ElementRef;
  constructor(
    private router: Router,
    private viewPortScroller: ViewportScroller,
    public loaderService: LoaderService,
    private customCookieService: CustomCookieService,
    private authorizationService: AuthorizationService,
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url.split('?')[0];
        this.redirectRoute = event.urlAfterRedirects.split('?')[0];
        this.viewPortScroller.scrollToPosition([0, 0]);
        const clientId: string = this.customCookieService.getData('ui-clinetId', true);
        /// Validate client ID on each public route change
        if (this.currentRoute.match(this.regexPrivateRoutes)) {
          console.log('On page client id validation')
          this.validateClinetId(clientId)
        }
        switch (this.currentRoute) {
          case '/main/home':
            this.showSignOutButton = false;
            this.showHeaderLogo = false;
            break;
          case '/account/order-confirmation':
            this.showSignOutButton = false;
            break;
          default:
            if (clientId) {
              this.showSignOutButton = true;
            }
            this.showHeaderLogo = true;
        }
      }
    });
  }


  private validateClinetId(id: string): void {
    const requestBody: IdValidationRequestBody = {
      clientID: id,
      redirect_uri: ''
    }
    this.authorizationService.validateClientId(requestBody)
      .subscribe(
        {
          next: (response: IdValidationResponse) => {
            let validateResponse: IdValidationResponse = response;
          },
          error: (error: any) => {
            this.router.navigate(['main/invalid-clientid']);
          }
        }
    )
  }

  ngOnInit() {}
  ngOnChanges() {}
}
